import React from 'react';
import axios from 'axios';
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useNotifications } from '../Components/Context/NotificationsCountContext';

import Logo from '../Components/Logo';
import Loading from '../Components/Loading';
import WarningPanel from '../Components/WarningPanel';
import LegalNotice from '../Components/Legal/LegalNotice';
import UnavailableSystem from '../Components/UnavailableSystem';

import styles from '../styles/Auth.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

export default function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [status, setStatus] = React.useState('');
  
    const [dbStatus, setDbStatus] = React.useState('checking');
    const [loading, setLoading] = React.useState(true);
    const [loadingButton, setLoadingButton] = React.useState(false);

    const [searchParams] = useSearchParams();
    const redirect = searchParams.get('redirect') || '/home';

    React.useEffect(() => {
      const fetchData = async () => {
        try {
            const response = await axios.get('/api/health');
            if (response.status === 200) {
                setDbStatus('connected');
            }
        } catch (err) {
            setDbStatus('Отсутствует подключение к серверу');
            console.log('Database connection error:', err);
        } finally {
            setLoading(false);
        }
    };
  
    fetchData();
    }, []);
  
    const { refetch } = useNotifications();
  
    const handleLogin = async () => {
        setLoadingButton(true);

        axios.post('/api/login', {
            email,
            password
        })
        .then((response) => {
            localStorage.setItem('token', response.data.token);
            refetch();
            navigate(redirect);
        })
        .catch((error) => {
            setLoadingButton(false);
            setStatus(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            setTimeout(() => {
                setStatus('');
            }, 4000);
        })
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <>
        {loading ? (
            <Loading />
        ) : dbStatus === 'connected' ? (
            <>
                <div className={styles.indexMain}>
                    <div className={styles.lining}>
                        <div className={styles.leftSide}>
                            <span>
                                <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                    <Logo to='/' position='relative' />
                                    <div className={styles.closeBtnContainerMobile}>
                                        <IconContainer Icon={XIcon} onClick={() => navigate('/')} size = '20' color = 'black' className = '' />
                                    </div>
                                </div>
                                <h1>Вход в Личный кабинет арбитражного управляющего</h1>
                                <a>Введите адрес электронной почты</a>
                                <div className={styles.inputWrapper}>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Введите email"
                                        minLength="3"
                                        maxLength="100"
                                        required
                                    />
                                </div>
                                <a>Введите пароль</a>
                                <div className={styles.inputWrapper}>
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Введите пароль"
                                        minLength="4"
                                        maxLength="180"
                                        required
                                    />
                                    <a href="/auth/reset-password" style={{color: '#5282ff', textDecoration: 'underline', fontSize: '12px'}}>Забыли пароль?</a>
                                </div>
                            </span>
                            <span>
                                {status && <WarningPanel text={status} />}
                                {loadingButton ? 
                                    <Loading /> 
                                    : 
                                    <button 
                                        type='button'
                                        className='button maxWidth' 
                                        onClick={handleLogin}
                                    >
                                        Войти
                                    </button>
                                }
                                <LegalNotice />
                            </span>
                        </div>
                        <div className={styles.rightSide}>
                            <div className={styles.closeBtnContainer}>
                                <IconContainer Icon={XIcon} onClick={() => navigate('/')} size = '20' color = 'black' className = '' />
                            </div>
                            <span>
                                <div className={styles.additionalBtn}>
                                    <img src='/img/icons/signin.svg' alt='Вход' />
                                    <span>
                                        <h2>Ещё нет учётной записи?</h2>
                                        <Link to='/auth/registration'>Перейти к странице регистрации</Link>
                                    </span>
                                </div>
                                <div className={styles.additionalBtn}>
                                    <img src='/img/icons/comment-question.svg' alt='Поддержка' />
                                    <span>
                                        <h2>Возникла проблема?</h2>
                                        <Link to='/send-feedback'>Обратиться в поддержку</Link>
                                    </span>
                                </div>
                                <div className={styles.additionalBtn}>
                                    <img src='/img/icons/file-info-alt.svg' alt='Юридическая информация' />
                                    <span>
                                        <h2>Обратите внимание</h2>
                                        <Link to='/legal/privacy-policy'>Пользовательское соглашение и политика конфиденциальности</Link>
                                    </span>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </>
        ) : (
            <UnavailableSystem dbStatus={dbStatus} />
        )}
        </>
    )
};
